import { useState, useEffect } from "react";
import {
  addCommentAction,
  getPostAction,
  getComPostsAction,
  getOwnPostAction,
  clearCommentFailAction,
} from "../../redux/actions/postActions";
import { useDispatch, useSelector } from "react-redux";
import InappropriatePost from "../modals/InappropriatePostModal";

const CommentForm = ({ communityId, postId, parentCommentId = null, mentionUser = "", className = "" }) => {
  const dispatch = useDispatch();
  const [showInappropriateContentModal, setShowInappropriateContentModal] = useState(false);

  const [content, setContent] = useState(mentionUser ? `@${mentionUser} ` : "");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newComment = {
      content,
      postId,
      parentCommentId,
    };

    try {
      setIsLoading(true);
      await dispatch(addCommentAction(postId, newComment));
      await dispatch(getPostAction(postId));
      await dispatch(getOwnPostAction(postId));

      setContent("");
      await dispatch(getComPostsAction(communityId));
    } finally {
      setIsLoading(false);
    }
  };

  const isCommentInappropriate = useSelector((state) => state.posts?.isCommentInappropriate);

  useEffect(() => {
    if (isCommentInappropriate) {
      setShowInappropriateContentModal(true);
    }
  }, [isCommentInappropriate]);

  return (
    <div>
      <InappropriatePost
        closeInappropriateContentModal={() => {
          setShowInappropriateContentModal(false);
          dispatch(clearCommentFailAction());
        }}
        showInappropriateContentModal={showInappropriateContentModal}
        contentType={"comment"}
      />

      <form onSubmit={handleSubmit}>
        <div className="my-4 relative">
          <textarea
            className={`w-full px-3 py-2 pb-8 border rounded-md focus:outline-none focus:border-primary-600 resize-none font-roboto-flex ${className === 'compact' ? 'text-sm' : ''}`}
            name="content"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            maxLength={250}
            required
            placeholder={parentCommentId ? "Write a reply..." : "Write a comment..."}
            rows={className === 'compact' ? 1 : 3}
            style={className === 'compact' ? { minHeight: '32px', maxHeight: '80px' } : {}}
          />
          <div className="absolute bottom-2 right-3 text-xs text-gray-500 font-roboto-flex bg-white px-1 rounded">
            {content.length}/250
          </div>
        </div>
        <div className="flex justify-end">
          <button
            className={`px-4 py-2 text-sm font-medium text-white bg-primary-700 rounded-md hover:bg-primary-800 focus:outline-none focus:bg-primary-800 font-roboto-flex ${className === 'compact' ? 'px-3 py-1 text-xs' : ''}`}
            type="submit"
            disabled={isLoading}
            style={{
              opacity: isLoading ? 0.5 : 1,
              cursor: isLoading ? "not-allowed" : "pointer",
            }}
          >
            {isLoading ? "Loading..." : parentCommentId ? "Reply" : "Comment"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CommentForm;

